import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Start", href: "#hero" },
  { label: "O projekcie", href: "#about" },
  { label: "Partnerzy", href: "#partners" },
  { label: "Wydarzenia B2B", href: "#events" },
  { label: "Kontakt", href: "#contact" },
];

export default function MHNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (href: string) => {
    setMenuOpen(false);
    if (!isHome) return;
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled ? "bg-white border-b border-gray-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/d3f566fff327433480db44ef3a925506.png"
            alt="Meet Hiszpania"
            className="h-12 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            isHome ? (
              <button
                key={link.label}
                onClick={() => handleAnchor(link.href)}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? "text-gray-700 hover:text-[#CC1F1A] hover:bg-red-50"
                    : "text-white/90 hover:text-white hover:bg-white/10"
                }`}
              >
                {link.label}
              </button>
            ) : (
              <Link
                key={link.label}
                to="/"
                className="px-4 py-2 text-sm font-medium rounded-md text-gray-700 hover:text-[#CC1F1A] hover:bg-red-50 transition-colors whitespace-nowrap"
              >
                {link.label}
              </Link>
            )
          ))}

          {/* Direct link to Playitas Resort */}
          <Link
            to="/playitas"
            className={`ml-1 flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-bold uppercase tracking-widest rounded-full border transition-all whitespace-nowrap ${
              scrolled
                ? "border-[#CC1F1A] text-[#CC1F1A] hover:bg-[#CC1F1A] hover:text-white"
                : "border-white/60 text-white hover:bg-white hover:text-[#CC1F1A]"
            }`}
          >
            <i className="ri-hotel-line text-sm" />
            Playitas Resort
          </Link>
        </nav>

        <button
          onClick={() => handleAnchor("#contact")}
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white rounded-lg transition-all cursor-pointer whitespace-nowrap hover:opacity-90"
          style={{ backgroundColor: "#CC1F1A" }}
        >
          Współpraca
          <i className="ri-arrow-right-line text-base" />
        </button>

        <button
          className="lg:hidden flex flex-col gap-1.5 w-8 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={`block h-0.5 w-full transition-colors ${scrolled ? "bg-gray-800" : "bg-white"}`} />
          <span className={`block h-0.5 w-3/4 transition-colors ${scrolled ? "bg-gray-800" : "bg-white"}`} />
          <span className={`block h-0.5 w-1/2 transition-colors ${scrolled ? "bg-gray-800" : "bg-white"}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-5 flex flex-col gap-3">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleAnchor(link.href)}
              className="text-sm font-medium text-gray-700 hover:text-[#CC1F1A] text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}

          {/* Playitas link in mobile menu */}
          <Link
            to="/playitas"
            onClick={() => setMenuOpen(false)}
            className="flex items-center gap-2 text-sm font-bold text-[#CC1F1A] cursor-pointer whitespace-nowrap"
          >
            <i className="ri-hotel-line" />
            Playitas Resort
          </Link>

          <button
            onClick={() => handleAnchor("#contact")}
            className="mt-2 px-4 py-2.5 text-sm font-semibold text-white rounded-lg cursor-pointer whitespace-nowrap"
            style={{ backgroundColor: "#CC1F1A" }}
          >
            Współpraca
          </button>
        </div>
      )}
    </header>
  );
}
